const mediaGetters = {
  getSlides: (state) => state.slides,
  getSlide: (state) => state.slide,
  getTextPages: (state) => state.textPages,
  getTextPage: (state) => state.textPage,
  getMediaCategories: (state) => state.mediaCategories,
  getMedias: (state) => state.medias,
  getMediaPage: (state) => state.mediaPage,
  getMediaPageFiles: (state) => state.mediaPageFiles,
  getTotalMediaFiles: (state) => state.totalMediaFiles,
  getMediaFiles: (state) => state.mediaFiles
}

export { mediaGetters }
